// extracted by mini-css-extract-plugin
export default {"container":"IW-z","title":"JW-z","link":"KW-z"};